
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperFunctions } from 'bowman-commons';
import { BowmanCacheService } from 'bowman-cache';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActionResult } from 'bowman-commons';
import { DashboardDto } from 'src/app/dashboard/model/dashboard-dto';
import { DashboardGroupAuthorization } from 'src/app/security/model/dashboard-group-authorization';
import { BowmanLoggerService } from 'bowman-logger';
import { Dashboard } from 'src/app/dashboard/model/dashboard';

@Injectable()
export class DashboardManagerService {
  private _mainUrl: string = window.location.pathname.replace('/gui/', '') + '/api/dashboard/'.replace('//', '/').replace('index.html', '');;
  headers: HttpHeaders = new HttpHeaders();


  constructor(private _http: HttpClient, private _bowmanCacheService: BowmanCacheService, private _loggerService: BowmanLoggerService) {
    this.headers = new HttpHeaders();
    this.headers.set("Accept", "application/json");

  }
  get mainUrl() {
    return this._mainUrl;
  }

  /**
   * Recupera il contenuto di una dashboard partendo dall'id
   * @param id L'id della dashboard
   */
  readDashboardContent(id): Observable<ActionResult<Dashboard>> {
    const dataUrl = this.mainUrl + 'read/' + id;
    return this._http.get<ActionResult<string>>(dataUrl, { headers: this.headers }).pipe(map(x => {
      let ar: ActionResult<Dashboard> = new ActionResult<Dashboard>();
      ar = HelperFunctions.cloneObject(x);
      ar.result = JSON.parse(x.result);
      return ar;
    }), catchError(this.handleError));
  }

  /**Recupera una lista di dashboard appartenenti all'utente corrente*/
  getUserDashboardsList(): Observable<ActionResult<Array<DashboardDto>>> {
    const dataUrl = this.mainUrl + 'list/user';
    return this._http.get<ActionResult<Array<DashboardDto>>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  /**Recupera una lista di dashboard appartenenti al gruppo corrente*/
  getGroupsDashboardsList(): Observable<ActionResult<Array<DashboardDto>>> {
    const dataUrl = this.mainUrl + 'list/groups';
    return this._http.get<ActionResult<Array<DashboardDto>>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  /**Recupera una lista di tutte le dashboard presenti nel dao*/
  getAllDashboardsList(): Observable<Array<DashboardDto>> {
    const dataUrl = this.mainUrl + 'list/all';
    return this._http.get<Array<DashboardDto>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }
  /**Recupera una lista di Dashboard Authorizations appartenenti al gruppo corrente*/
  getDashboardsAuthorizations(): Observable<ActionResult<Array<DashboardGroupAuthorization>>> {
    const dataUrl = this.mainUrl + 'listAuthorizations/byRoles';
    return this._http.get<ActionResult<Array<DashboardGroupAuthorization>>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }

  /**
   * Recupera una lista di Dashboard Authorizations legata al dashboardId passato come parametro
   * @param dashboard Il contenuto della dashboard
   */
  getDashboardsAuthorizationsByDashboard(idDash: string): Observable<ActionResult<Array<DashboardGroupAuthorization>>> {
    const dataUrl = this.mainUrl + 'listAuthorizations/byDashboard/' + idDash;
    return this._http.get<ActionResult<Array<DashboardGroupAuthorization>>>(dataUrl, { headers: this.headers }).pipe(catchError(this.handleError));
  }
  /**
   * Effettua un'update della dashboard passata come parametro
   * @param dashboard Il contenuto della dashboard
   */
  public updateDashboard(dashboard: DashboardDto): Observable<ActionResult<boolean>> {
    let headers: HttpHeaders = new HttpHeaders();
    headers.set("Accept", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("Content-Type", "application/json");
    this._bowmanCacheService.flushServiceCacheByMethod('getUserDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getGroupsDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getAllDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizations');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizationsByDashboard');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizations');


    return this._http.put<ActionResult<boolean>>(this.mainUrl + 'update', dashboard, { headers: headers }).pipe(catchError(this.handleError));
  }


  public createDashboard(dashboard: DashboardDto): Observable<ActionResult<string>> {
    let headers: HttpHeaders = new HttpHeaders();
    headers.set("Accept", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("Content-Type", "application/json");
    this._bowmanCacheService.flushServiceCacheByMethod('getUserDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getGroupsDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getAllDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizations');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizationsByDashboard');
    return this._http.post<ActionResult<string>>(this.mainUrl + 'create', dashboard, { headers: headers }).pipe(catchError(this.handleError));
  }

  public deleteDashboard(dashboardId: string): Observable<ActionResult<Boolean>> {
    let headers: HttpHeaders = new HttpHeaders();
    headers.set("Accept", "application/json");
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("Content-Type", "application/json");
    this._bowmanCacheService.flushServiceCacheByMethod('getUserDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getGroupsDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getAllDashboardsList');
    this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizations'); this._bowmanCacheService.flushServiceCacheByMethod('getDashboardsAuthorizationsByDashboard');
    return this._http.delete<ActionResult<Boolean>>(this.mainUrl + 'delete' + '/' + dashboardId, { headers: headers }).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    let parsedError: any;
    if (error && error.error && error.error.message) {
      parsedError = error.error.message;
    } else if (error && error.message) {
      parsedError = error.message;
    } else if (error && error._body) {
      parsedError = error._body;
    } else {
      parsedError = 'Dashboard Manager Service Error';
    }
    return observableThrowError(parsedError);
  }
}